interface Category {
  slug: string;
  name: string;
  info_text?: null | string;
  info_link?: null | string;
  info_button_label?: null | string;
}

interface Opts {
  categories: {
    [key: string]: Category;
  };
}

export function ProjectsFilter(opts: Opts) {
  /**
   * Prepare all elements in use
   */
  // prettier-ignore
  const el = {
    queryInput: document.querySelector<HTMLInputElement>('#ProjectsFilter-queryInput'),
    projectsGrid: document.querySelector<HTMLElement>('.ProjectsGrid'),
    empty: document.querySelector<HTMLElement>('.ProjectsGrid-block--empty'),
  };

  const alreadyFiltered = el.projectsGrid?.classList?.contains(
    'ProjectsGrid--filtered'
  );

  /**
   * Prepare the data structure for all projects
   */
  const projects = [
    ...document.querySelectorAll<HTMLElement>(
      '.ProjectsGrid .ProjectsGrid-block'
    ),
  ].map((element: HTMLElement) => ({
    element,
    title: element.getAttribute('data-title') ?? '',
    lcTitle: element.getAttribute('data-title')?.toLocaleLowerCase() ?? '',
    categories: JSON.parse(
      element.getAttribute('data-categories') ?? '[]'
    ) as string[],
  }));

  let url = new URL(window.location.toString());

  /**
   * Click handlers and initialization
   */

  // document
  //   .querySelectorAll<HTMLElement>('.ProjectsFilter-clearFilter')
  //   .forEach((element) => {
  //     element.addEventListener('click', (e) => {
  //       const target = e.currentTarget as HTMLAnchorElement;
  //       target.dataset.noLink = 'true';
  //       e.preventDefault();
  //       clearFilter();
  //     });
  //   });

  applyFilter();

  el.queryInput?.addEventListener('input', (evt) => {
    evt.preventDefault();
    applyFilter();
  });

  function clearFilter(): void {
    url.searchParams.delete('cat');
    if (el.queryInput) {
      el.queryInput.value = '';
    }
    history.pushState('', '', url.toString());
    applyFilter();
  }

  window.addEventListener('popstate', () => {
    url = new URL(window.location.toString());
    applyFilter();
  });

  /**
   * Apply the current filter/category to the project grid and sidebar
   */
  function applyFilter() {
    const query = el.queryInput?.value ?? '';
    const lcQuery = query.toLocaleLowerCase();

    /**
     * Toggle the grid class. We use this to only show
     * "featured size" projects when a category is not selected.
     */
    el.projectsGrid?.classList.toggle(
      'ProjectsGrid--filtered',
      alreadyFiltered || Boolean(query)
    );

    /**
     * Loop through the projects,
     * showing/hiding according to filters
     */
    let noProjectsVisible = true;
    projects.forEach((p) => {
      const isInSearch = !query || (query && p.lcTitle.indexOf(lcQuery) >= 0);
      if (isInSearch) {
        noProjectsVisible = false;
        p.element.classList.remove('hidden');
      } else {
        p.element.classList.add('hidden');
      }
    });

    /**
     * Show the "No results" block if there are no matching projects.
     */
    el.empty?.classList.toggle('hidden', !noProjectsVisible);
  }
}
